import { useEffect, useMemo, useState } from 'react';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { NotificationElement } from 'core/components/Notification';
import { ApiStatus, InputType, NotificationPosition } from 'core/enums';
import { IResetPricingForm } from 'quotes/types';
import { Size } from 'theme/enums';

interface IProps {
  isOpen?: boolean;
  onClose?: (reset?: UseFormReset<IResetPricingForm>) => void;
  onSubmit?: (reset?: UseFormReset<IResetPricingForm>) => (data: IResetPricingForm) => void;
  quotePartsCount?: number;
}

const QuotePartResetPricingFormView = ({
  isOpen = false,
  onClose,
  onSubmit,
  quotePartsCount = 0,
}: IProps) => {
  const [hintOpen, setHintOpen] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    setHintOpen(isOpen);
  }, [isOpen]);

  const hintNotification = {
    title: t('titleHint'),
    message: t('messageHintResetPricing'),
    type: ApiStatus.INFO,
    position: NotificationPosition.FORM,
    withoutCloseButton: true,
  };

  const subtitle = useMemo(
    () =>
      quotePartsCount > 0 ? t('subtitleForSelectedPartsCount', { count: quotePartsCount }) : null,
    [quotePartsCount, t]
  );

  return (
    <Form
      title={t('titleResetPricing')}
      subtitle={subtitle}
      isOpen={isOpen}
      onClose={onClose}
      submitBtnLabel={t('buttonLabelResetPricing')}
      cancelBtnLabel={t('buttonLabelCancel')}
      onSubmit={onSubmit}
      size={Size.SM}
    >
      <NotificationElement {...hintNotification} showNotification={hintOpen} />

      <FormField
        name="cost"
        type={InputType.CHECKBOX}
        inputProps={{
          label: t('labelCosts'),
        }}
      />

      <FormField
        name="price"
        type={InputType.CHECKBOX}
        inputProps={{
          label: t('labelPrices'),
        }}
      />
    </Form>
  );
};

export default QuotePartResetPricingFormView;
